import Icon from '../components/Icon.vue'

Icon.register({
  'chart-bar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M332.8 320c-6.4 0-12.8-6.4-12.8-12.8v-134.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v134.4c0 6.4-6.4 12.8-12.8 12.8h-38.4zM428.8 320c-6.4 0-12.8-6.4-12.8-12.8v-230.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v230.4c0 6.4-6.4 12.8-12.8 12.8h-38.4zM140.8 320c-6.4 0-12.8-6.4-12.8-12.8v-70.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v70.4c0 6.4-6.4 12.8-12.8 12.8h-38.4zM236.8 320c-6.4 0-12.8-6.4-12.8-12.8v-198.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v198.4c0 6.4-6.4 12.8-12.8 12.8h-38.4zM496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-464c-17.7 0-32-14.3-32-32v-336c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v304h432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chart-bar.js
// module id = 1169
// module chunks = 0